import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdSend: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 16 17" fill="none" {...props}>
      <Path
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        focusable={false}
        d="M8.19046 8.12608L1.69726 7.62661L0.795917 1.31723L15.1614 8.49998L0.795917 15.6827L1.69726 9.37335L8.19046 8.87387L8.19046 8.12608Z"
        stroke="currentColor"
        strokeWidth="0.75"
      />
    </Svg>
  );
};

export default PdSend;
